<template>
    <div class="text-container">

        <h1>Changer le texte défilant</h1>
        <InputCommon v-model="scrollingTitle" label="Nouveau titre :" bordered gray />
        <InputCommon v-model="scrollingText" label="Nouveau texte défilant :" bordered gray />
        <button @click="submit()" class="submit-button">Enregistrer</button>
    </div>
</template>
<script setup lang="ts">
import InputCommon from '@/components/common/input/InputCommon.vue';
import { ref, onMounted } from 'vue';
import { toast } from 'vue-sonner';

const scrollingText = ref('');
const scrollingTitle = ref('');

onMounted(() => {
    scrollingText.value = localStorage.getItem('scrollingText') || scrollingText.value;
    scrollingTitle.value = localStorage.getItem('scrollingTitle') || scrollingTitle.value;
});

function submit() {
    localStorage.setItem('scrollingText', scrollingText.value || '');
    localStorage.setItem('scrollingTitle', scrollingTitle.value || '');
    toast.success("Texte changé avec succès");
}

</script>
<style scoped>
.submit-button {
    margin-top: 10px;
    padding: 10px 20px;
    background-color: var(--vc-primary);
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
}

.submit-button:hover {
    background-color: var(--vc-primary-dark, #0056b3);
}

.saved-message {
    margin-top: 10px;
    color: green;
    font-weight: bold;
}

.text-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 30px;
    height: 100vh;
}
</style>